import { createFileRoute, redirect } from "@tanstack/react-router";
import { PublicProfileView } from "@/components/public-profile-view";
import { useReferralCapture } from "@/hooks/useReferral";
import { getPublicProfilePage } from "@/lib/profile.functions";
import { profileHead } from "@/lib/profile-seo";

export const Route = createFileRoute("/user/$slug")({
  validateSearch: (search: Record<string, unknown>) => ({
    ref: typeof search["ref"] === "string" ? (search["ref"] as string) : undefined,
  }),
  loader: async ({ params }) => {
    let data;
    try {
      data = await getPublicProfilePage({ data: { slug: params.slug } });
    } catch {
      data = null;
    }
    if (!data?.profile) {
      throw redirect({ to: "/", replace: true });
    }
    return data;
  },
  head: ({ params, loaderData }) => profileHead("user", params.slug, loaderData),
  component: UserProfileRoute,
});

function UserProfileRoute() {
  const { slug } = Route.useParams();
  const data = Route.useLoaderData();
  useReferralCapture(data?.profile?.referral_code ?? null);

  return (
    <PublicProfileView
      variant="user"
      path={`/user/${slug}`}
      data={{
        profile: data.profile!,
        socials: data.socials,
        services: data.services,
        posts: data.posts,
        offers: data.offers,
        sections: data.sections,
        articles: data.articles,
        listings: data.listings,
      }}
    />
  );
}
